import { api } from "@/lib/api";

// WEBXR.8E.6A — appels administrateur Qualification Esri. La clé n'est jamais conservée ni relue.
const intent = (v) => ({ headers: { "X-SKYCORE-Admin-Intent": v } });

export const qualApi = {
  load: async () => {
    const [q, sec, cfg, audit, ev] = await Promise.all([
      api.get("/maps/admin/qualification"), api.get("/maps/admin/secret/esri"),
      api.get("/maps/admin/config"), api.get("/maps/admin/audit"), api.get("/maps/admin/contract-evidence"),
    ]);
    const evidence = Object.fromEntries(ev.data.rows.map((r) => [r.item, r]));
    return { q: q.data, secret: sec.data, esri: cfg.data.providers["esri-static"], killSwitch: cfg.data.kill_switch, audit: audit.data.rows.slice(0, 25), evidence };
  },
  patch: (body) => api.patch("/maps/admin/config/esri-static", body),
  declare: (body) => api.post("/maps/admin/contract-evidence", body),
  probe: () => api.post("/maps/admin/qualification/probe", null, intent("esri-probe")),
  killSwitch: (engaged, confirm) => api.post("/maps/admin/kill-switch", { engaged, reason: engaged ? "ARRÊT D'URGENCE — panneau qualification" : "RÉACTIVATION", confirm }),
  unblock: () => api.post("/maps/admin/unblock/esri-static"),
  reset: (confirm) => api.post("/maps/admin/qualification/reset", { confirm }),
};

export function qualErr(e) {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object") return [d.code, d.message, d.failed && d.failed.length ? `manquants : ${d.failed.join(", ")}` : null].filter(Boolean).join(" — ");
  return typeof d === "string" ? d : "Erreur réseau";
}

export const STATE_LABELS = {
  CONFIGURATION_INCOMPLETE: "Configuration incomplète",
  CONFIGURATION_READY: "Prêt à tester",
  AUTHORIZED_PROBE: "Connexion testée",
  QUALIFICATION_GO: "Qualification GO",
  QUALIFICATION_RUNNING: "Campagne en cours",
  QUALIFICATION_COMPLETED: "Qualification terminée",
  QUALIFICATION_FAILED: "Qualification en échec",
};

export const CARD = "bg-[#141414] border border-white/10 rounded-sm p-4 space-y-3";
export const INPUT = "w-full bg-[#0A0A0A] border border-white/15 focus:border-[#3B82F6] outline-none rounded-sm px-3 py-2 font-mono text-xs";
export const BTN = "inline-flex items-center gap-1.5 border border-white/15 hover:bg-white/10 rounded-sm font-mono text-[10px] uppercase tracking-wider px-3 py-1.5 disabled:opacity-30 disabled:cursor-not-allowed transition-colors";
export const LABEL = "font-mono text-[9px] tracking-[0.2em] uppercase text-[#A3A3A3] block mb-1";
